export const TALENTQ_ASSESSMENT_STATUSES = {
  NOT_STARTED: 1,
  IN_PROGRESS: 2,
  IN_PROGRESS_AND_REPEAT: 3,
  COMPLETE: 4
};